import leCard from './le-card.vue';

leCard.install = function (Vue) {
    Vue.component(leCard.name, leCard);
};

export default leCard;
